export { buildSymbolIndexImpl as buildSymbolIndexInWorkerHost } from './build-symbol-index-impl.js';
